import type { AppModule } from '@/config/types'
import { TmBaseError } from '@/core/error/tmBaseError'

export class TmServiceNotBoundError extends TmBaseError<{ serviceName: string; module: AppModule }> {
  public name = 'TmServiceNotBoundError'

  public readonly serviceName: string

  public readonly module: AppModule

  protected isMonitored = true

  protected isNotified = false

  constructor(serviceName: string, module: AppModule) {
    super(`Service "${serviceName}" is not bound because module "${module}" is not loaded yet.`)
    this.serviceName = serviceName
    this.module = module
    this.setData({ serviceName, module })
  }
}
